import { render, staticRenderFns } from "./BE.vue?vue&type=template&id=ec88bd9e&scoped=true&"
import script from "./BE.vue?vue&type=script&lang=ts&"
export * from "./BE.vue?vue&type=script&lang=ts&"
import style0 from "./BE.vue?vue&type=style&index=0&id=ec88bd9e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec88bd9e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VContainer})
